import { render, staticRenderFns } from "./ManualOrderB2b.vue?vue&type=template&id=f6ef25d2"
import script from "./ManualOrderB2b.vue?vue&type=script&lang=js"
export * from "./ManualOrderB2b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports